import React from 'react';
import type { SocialEmbedConfig } from './types';

interface SocialEmbedProps {
  config: SocialEmbedConfig;
}

export const SocialEmbed: React.FC<SocialEmbedProps> = ({ config }) => {
  switch (config.platform) {
    case 'twitter':
      return (
        <blockquote className="twitter-tweet" data-theme={config.theme}>
          <a href={config.postUrl}>Loading tweet...</a>
        </blockquote>
      );

    case 'instagram':
      return (
        <blockquote
          className="instagram-media"
          data-instgrm-captioned={!config.hideCaption}
          style={{ width: config.width || '100%' }}
        >
          <a href={config.postUrl}>Loading Instagram post...</a>
        </blockquote>
      );

    case 'facebook':
      return <div className="fb-post" data-href={config.postUrl} data-width={config.width} />;

    case 'linkedin':
      return (
        <iframe
          src={`https://www.linkedin.com/embed/feed/update/${config.postId}`}
          width={config.width || '504'}
          height={config.height || '800'}
          frameBorder="0"
          allowFullScreen
          title="Embedded LinkedIn Post"
        />
      );

    case 'tiktok':
      return (
        <blockquote
          className="tiktok-embed"
          cite={config.postUrl}
          data-video-id={config.postId}
          style={{ maxWidth: config.width || '605px', minWidth: '325px' }}
        >
          <a href={config.postUrl}>Loading TikTok...</a>
        </blockquote>
      );

    default:
      return null;
  }
};

interface SocialScriptsProps {
  platform: SocialEmbedConfig['platform'];
}

export const SocialScripts: React.FC<SocialScriptsProps> = ({ platform }) => {
  return (
    <>
      {platform === 'twitter' && <script async src="https://platform.twitter.com/widgets.js" />}
      {platform === 'instagram' && <script async src="//www.instagram.com/embed.js" />}
      {platform === 'facebook' && <div id="fb-root" />}
      {platform === 'tiktok' && <script async src="https://www.tiktok.com/embed.js" />}
    </>
  );
};
